module.exports = __webpack_public_path__ + "img/reward_completed.74af2197.png";